import {
  CollectionFunctionGroup,
  CollectionFunctionGroupFormData,
} from 'data/collectionFunctionGroup/collectionFunctionGroup.types';
import { adaptToSubmit } from 'data/collectionFunctionGroup/collectionFunctionGroup.adapter';
import { WithAuditDetails, AuditDetails, Operation } from 'data/types';
import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';

export default function getCollectionFunctionGroupDataToSubmit(
  collectionFunctionGroupFormData: CollectionFunctionGroupFormData,
  originalCollectionFunctionGroup: CollectionFunctionGroup | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): WithAuditDetails<CollectionFunctionGroup> {
  const collectionFunctionGroup = adaptToSubmit(collectionFunctionGroupFormData);

  const collectionFunctionGroupBody: WithAuditDetails<CollectionFunctionGroup> = {
    data: collectionFunctionGroup,
  };

  let actionType = AuditActionType.COLLECTION_FUNCTION_GROUP_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.COLLECTION_FUNCTION_GROUP_EDIT;
    isEdit = true;
  }

  if (isAuditEnabled) {
    const auditDetails = getAuditDetails(
      isAuditEnabled,
      userId,
      userName,
      getAuditFieldInfo(collectionFunctionGroup, null, isEdit, originalCollectionFunctionGroup),
      collectionFunctionGroup.name,
      AuditService.CF_GROUP,
      actionType,
    );
    collectionFunctionGroupBody.auditDetails = auditDetails as AuditDetails;
  }

  return collectionFunctionGroupBody;
}
